export default "__VITE_ASSET__BBuikwfs__"